import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const badgeVariants = cva(
	'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
	{
		variants: {
			variant: {
				default:
					'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
				secondary:
					'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
				destructive:
					'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
				active:
					'border-transparent bg-active text-active-foreground hover:bg-active/80',
				warning:
					'border-transparent bg-warning text-warning-foreground hover:bg-warning/80',
				info: 'border-transparent bg-info text-info-foreground hover:bg-info/80',
				success:
					// The pale tint members see on "You're going" in the mobile app (#952).
					// bg-teal-100 is a fixed light color, so this pill doesn't adapt to dark mode.
					'border-secondary-foreground bg-teal-100 text-secondary-foreground',
				disabled:
					'border-transparent bg-disabled text-disabled-foreground hover:bg-disabled/80',
				outline: 'border border-secondary-foreground text-secondary-foreground',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
)

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
	({ className, variant, ...props }, ref) => {
		return (
			<div
				className={cn(badgeVariants({ variant }), className)}
				{...props}
				ref={ref}
			/>
		)
	},
)

export { Badge, badgeVariants }
